import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Department } from './types'

export const DEPARTMENTS_QUERY: TypedDocumentNode<
  { departments: Department[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Departments($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    departments(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const DEPARTMENT_QUERY: TypedDocumentNode<
  { department: Department | null },
  { id: string }
> = gql`
  query Department($id: ID!) {
    department(id: $id) {
      id client_id application_id name subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`
